import { request } from './apiClient';

// Monta a query string a partir de um objeto de filtros, ignorando valores vazios.
function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length === 0) return;
      search.set(key, value.join(','));
      return;
    }
    search.set(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

// Lista os corpos de prova da Ficha de Ruptura, já com etiqueta/idade/nota fiscal/obra/empresa resolvidos no backend.
// Não traz carga/tipo de ruptura: a ficha sai em branco para preenchimento manual no laboratório.
export const getFichaRupturaData = async ({ dataRuptura, idObras, idEmpresas, page, pageSize } = {}) => {
  const qs = buildQuery({ dataRuptura, idObras, idEmpresas, page, pageSize });
  return await request(`/api/fichaRuptura${qs}`);
};

// Contagem de corpos de prova por data de ruptura (para o calendário), agregada no backend.
export const getFichaRupturaCalendario = async ({ idObras } = {}) => {
  const qs = buildQuery({ idObras });
  return await request(`/api/fichaRuptura/calendario${qs}`);
};
